class EventModel {
    constructor(data = {}) {
        this.id = data.id ?? null;

        // Sécurité si le backend renvoie encore "url1#url2"
        const img = data.imgEven ?? null;
        this.img = img && img !== "empty" ? img.split("#")[0] : null;

        this.title = data.nomEven ?? null;
        this.subtitle = data.sousNomEven ?? null;
        this.date = data.dateEven ?? null;
        this.ville = data.villeEven ?? null;
        this.rue = data.rueEven ?? null;
        this.category = data.categorie ?? null;
        this.likes = data.nbr_jaime ?? 0;
        this.views = data.nbr_vues ?? 0;
        this.clicks = data.nbr_clicks ?? 0;
        this.reserved = data.nbr_reserved ?? 0;
        this.isActive = data.is_active ?? true;
        this.site = data.site ?? null;
    }
}
class DashboardModel {
    constructor(data = {}) {
        const stats = data.statistics ?? {};

        this.statistics = {
            totalEvents: stats.total_events ?? 0,
            totalEventsChange: stats.totalEventsChange ?? 0,
            totalEventsPercent: stats.totalEventsPercent ?? 0,
            totalEventsPeriod: stats.totalEventsPeriod ?? 'week',

            totalViews: stats.total_views ?? 0,
            totalViewsChange: stats.totalViewsChange ?? 0,
            totalViewsPercent: stats.totalViewsPercent ?? 0,
            totalViewsPeriod: stats.totalViewsPeriod ?? 'week',

            totalLikes: stats.total_likes ?? 0,
            totalLikesChange: stats.totalLikesChange ?? 0,
            totalLikesPercent: stats.totalLikesPercent ?? 0,
            totalLikesPeriod: stats.totalLikesPeriod ?? 'week',

            totalReserved: stats.total_reserved ?? 0,

            totalClicks: stats.total_clicks ?? 0,
            totalClicksChange: stats.totalClicksChange ?? 0,
            totalClicksPercent: stats.totalClicksPercent ?? 0,
            totalClicksPeriod: stats.totalClicksPeriod ?? 'week',
        };

        // 3 derniers événements créés
        const lastEventsArray = Array.isArray(data.last_events) ? data.last_events : [];
        this.lastEvents = lastEventsArray.map((event) => new EventModel(event));

        // Classement des événements (pour les barres du dashboard)
        const topEventsArray = Array.isArray(data.top_events) ? data.top_events : [];
        this.topEvents = topEventsArray.map((event) => new EventModel(event));

        // Série temporelle sur 30 jours (pour la courbe)
        const evolutionArray = Array.isArray(data.evolution) ? data.evolution : [];
        this.evolution = evolutionArray.map((jour) => ({
            date: jour.date,
            views: Number(jour.views ?? 0),
            likes: Number(jour.likes ?? 0),
            clicks: Number(jour.clicks ?? 0),
        }));
                // Prochains événements (à venir)
        const upcomingArray = Array.isArray(data.upcoming_events) ? data.upcoming_events : [];
        this.upcomingEvents = upcomingArray.map((event) => new EventModel(event));
    }
}

export { EventModel, DashboardModel };
export default DashboardModel;